import type { Localizations } from "~/service/l10n";

const translations: Localizations = {
  'en-US': {
    'map.stores': 'Stores',
    'map.searchStores': 'Search stores...',
    'map.backToStores': 'Back to stores',
    'map.location': 'Location',
    'map.contactInformation': 'Contact information',
    'map.openingHours': 'Opening hours',
    'map.phone': 'Phone',
    'map.email': 'Email',
    'map.website': 'Website',
    'map.getDirections': 'Get directions',
    'map.noStoreSelected': 'No store selected',
    'routing.planRoute': 'Plan route',
    'routing.from': 'From',
    'routing.to': 'To',
    'routing.selectDestinationStore': 'Select destination store',
    'routing.searchStores': 'Search stores...',
    'routing.noStoresFound': 'No stores found',
    'routing.calculating': 'Calculating...',
    'routing.clearRoute': 'Clear route',
    'routing.showRoute': 'Show route',
    'routing.continueInstructionsForNextFloor': 'Continue instructions for next floor',
    'routing.tip': 'Tip:',
    'routing.tip-text': 'You can also click on any store on the map to set it as your destination.',
    'routing.back': 'Back',
    'routing.floor': 'Floor',
    'cookiebot.preferences' : 'preferences',
    'cookiebot.statistics' : 'statistics',
    'cookiebot.marketing' : 'marketing',
    'cookiebot.content_blocked' : "Please accept the %s cookies to see the content.",
    'cookiebot.change_consent' : 'Change consent'
  },
  'fi-FI': {
    'map.stores': 'Liikkeet',
    'map.searchStores': 'Hae liikkeitä...',
    'map.backToStores': 'Takaisin liikkeisiin',
    'map.location': 'Kerros',
    'map.contactInformation': 'Yhteystiedot',
    'map.openingHours': 'Aukioloaikaväli',
    'map.phone': 'Puhelin',
    'map.email': 'Sähköposti',
    'map.website': 'Nettisivu',
    'map.getDirections': 'Näytä reittiohjeet',
    'map.noStoreSelected': 'Ei liikkeitä valittu',
    'routing.planRoute': 'Suunnittele reitti',
    'routing.from': 'Mistä',
    'routing.to': 'Mihin',
    'routing.selectDestinationStore': 'Valitse kohde liike',
    'routing.searchStores': 'Hae liikkeitä...',
    'routing.noStoresFound': 'Ei liikkeitä löytynyt',
    'routing.calculating': 'Lasketaan reittiä...',
    'routing.clearRoute': 'Tyhjennä reitti',
    'routing.showRoute': 'Näytä reitti',
    'routing.continueInstructionsForNextFloor': 'Jatka ohjeita seuraavalle kerrokselle',
    'routing.tip': 'Vihje:',
    'routing.tip-text': 'Voit myös napsauttaa minkä tahansa liikkeen kartalla asettamaan sen kohdeksi.',
    'routing.back': 'Takaisin',
    'routing.floor': 'Kerros',
    'cookiebot.preferences' : 'mieltymys',
    'cookiebot.statistics' : 'tilasto',
    'cookiebot.marketing' : 'markkinointi',
    'cookiebot.content_blocked' : 'Jos sisältö ei näy, hyväksythän %sevästeet.',
    'cookiebot.change_consent' : 'Muuta hyväksyntää'
  },
  'sv-SE': {
    'map.stores': 'Butiker',
    'map.searchStores': 'Sök butiker...',
    'map.backToStores': 'Tillbaka till butikker',
    'map.location': 'Plats',
    'map.contactInformation': 'Kontaktinformation',
    'map.openingHours': 'Öppettider',
    'map.phone': 'Telefon',
    'map.email': 'E-post',
    'map.website': 'Webbplats',
    'map.getDirections': 'Få rutter',
    'map.noStoreSelected': 'Ingen butikk vald',
    'routing.planRoute': 'Planera rutt',
    'routing.from': 'Från',
    'routing.to': 'Till',
    'routing.selectDestinationStore': 'Välj destination butik',
    'routing.searchStores': 'Sök butiker...',
    'routing.noStoresFound': 'Inga butiker hittades',
    'routing.calculating': 'Beräknar rutt...',
    'routing.clearRoute': 'Rensa rutt',
    'routing.showRoute': 'Visa rutt',
    'routing.continueInstructionsForNextFloor': 'Fortsätt instruktioner för nästa våning',
    'routing.tip': 'Tips:',
    'routing.tip-text': 'Du kan också klicka på vilken butik som helst på kartan för att ställa in den som din destination.',
    'routing.back': 'Tillbaka',
    'routing.floor': 'Våning',
    'cookiebot.preferences' : 'preferens',
    'cookiebot.statistics' : 'statistik',
    'cookiebot.marketing' : 'marknadsförings',
    'cookiebot.content_blocked' : 'Vänligen acceptera %scookies för att se innehållet.',
    'cookiebot.change_consent' : 'Ändra ditt medgivande'
  },
  'nb-NO': {
    'map.stores': 'Butikker',
    'map.searchStores': 'Søk butikker...',
    'map.backToStores': 'Tilbake til butikker',
    'map.location': 'Lokasjon',
    'map.contactInformation': 'Kontaktinformasjon',
    'map.openingHours': 'Åpningstider',
    'map.phone': 'Telefon',
    'map.email': 'E-post',
    'map.website': 'Nettside',
    'map.getDirections': 'Få retninger',
    'map.noStoreSelected': 'Ingen butikk valgt',
    'cookiebot.preferences' : 'preferanse',
    'cookiebot.statistics' : 'statistikk',
    'cookiebot.marketing' : 'markedsførings',
    'cookiebot.content_blocked' : 'Godta %sinformasjonskapslene for å se innholdet.',
    'cookiebot.change_consent' : 'Endre samtykke'
  },
  'et-EE': {
    'map.stores': 'Kauplused',
    'map.searchStores': 'Otsi kauplusi...',
    'map.backToStores': 'Tagasi kauplusteni',
    'map.location': 'Asukoht',
    'map.contactInformation': 'Kontaktinfo',
    'map.openingHours': 'Avaaajad',
    'map.phone': 'Telefon',
    'map.email': 'E-post',
    'map.website': 'Veebileht',
    'map.getDirections': 'Näita reittiohjeita',
    'map.noStoreSelected': 'Ei kauplust valitud',
    'routing.planRoute': 'Planeeri reit',
    'routing.from': 'Alates',
    'routing.to': 'Kohale',
    'routing.selectDestinationStore': 'Vali kauplus kohale',
    'routing.searchStores': 'Otsi kauplusi...',
    'routing.noStoresFound': 'Ei kauplusi leitud',
    'routing.calculating': 'Arvutab reit...',
    'routing.clearRoute': 'Tühista reit',
    'routing.showRoute': 'Näita reit',
    'routing.continueInstructionsForNextFloor': 'Jätka juhiseid järgmisele kerale',
    'routing.tip': 'Näpunne:',
    'routing.tip-text': 'Võid ka klõpsata kauplust kartal, et selleks määrata kohale.',
    'routing.back': 'Tagasi',
    'routing.floor': 'Kerakorras',
    'cookiebot.preferences' : 'eelis',
    'cookiebot.statistics' : 'statistika',
    'cookiebot.marketing' : 'turundus',
    'cookiebot.content_blocked' : 'Sisu vaatamiseks nõustuge %sküpsistega.',
    'cookiebot.change_consent' : 'Muuda oma nõusolekut'
  },
  'da-DK': {
    'map.stores': 'Butikker',
    'map.searchStores': 'Søg butikker...',
    'map.backToStores': 'Tilbage til butikker',
    'map.location': 'Lokation',
    'map.contactInformation': 'Kontaktinformation',
    'map.openingHours': 'Åbningstider',
    'map.phone': 'Telefon',
    'map.email': 'E-post',
    'map.website': 'Webbplats',
    'map.getDirections': 'Få retninger',
    'map.noStoreSelected': 'Ingen butikk valgt',
    'routing.planRoute': 'Planlæg rute',
    'routing.from': 'Fra',
    'routing.to': 'Til',
    'routing.selectDestinationStore': 'Vælg destination butik',
    'routing.searchStores': 'Søg butikker...',
    'routing.noStoresFound': 'Ingen butikker fundet',
    'routing.calculating': 'Beregner rute...',
    'routing.clearRoute': 'Ryd rute',
    'routing.showRoute': 'Vis rute',
    'routing.continueInstructionsForNextFloor': 'Fortsæt instruktioner for næste etage',
    'routing.tip': 'Tip:',
    'routing.tip-text': 'Du kan også klikke på en hvilken som helst butik på kortet for at sætte den som din destination.',
    'routing.back': 'Tilbage',
    'routing.floor': 'Etage',
    'cookiebot.preferences' : 'præference',
    'cookiebot.statistics' : 'statistik',
    'cookiebot.marketing' : 'marketing',
    'cookiebot.content_blocked' : 'Accepter %scookies for at se indholdet.',
    'cookiebot.change_consent' : 'Ændring af dit samtykke'
  },
}

export default translations;